import { NativeEvent } from './NativeEvent';
import { ShareEvent } from './events/ShareEvent';

export interface ShareInput {
  title?: string;
  message: string;
  url?: string;
}

export type ShareOutcome =
  /** App nativo recebeu o ShareEvent — share sheet aberto pelo RN. */
  | 'native-app'
  /** Browser nativo abriu o share sheet via Web Share API. */
  | 'navigator'
  /** Usuário cancelou o share sheet. */
  | 'aborted'
  /** Nem app nem Web Share API disponíveis — caller deve cair em fallback. */
  | 'unsupported';

/**
 * Tenta compartilhar pelo melhor canal disponível.
 *
 *   1. Se estamos dentro do WebView do app, dispara `ShareEvent` (nativo).
 *   2. Caso contrário, tenta `navigator.share` (Web Share API).
 *   3. Se nada funcionar, retorna `'unsupported'` para o caller decidir
 *      o fallback (clipboard, WhatsApp, etc).
 */
export async function shareNative(input: ShareInput): Promise<ShareOutcome> {
  if (NativeEvent.isNativeApp()) {
    new ShareEvent(input).dispatch();

    return 'native-app';
  }

  if (
    typeof navigator !== 'undefined' &&
    typeof navigator.share === 'function'
  ) {
    try {
      await navigator.share({
        title: input.title,
        text: input.message,
        url: input.url,
      });

      return 'navigator';
    } catch (err) {
      if ((err as { name?: string })?.name === 'AbortError') {
        return 'aborted';
      }
    }
  }

  return 'unsupported';
}
